import React from "react";
import history from "../History";
import { Text } from "react-internationalization";

const Banner = (props) => {
  const { header, Body } = props;
  return (
    <div class="jumbotron1" >
      {history.location.pathname === "/webapp/Sharp/Individual/userCreation" ? (
        <p class="pt-1" /*style={{  fontSize: "20px" }}*/>
          <strong>
            <Text id="header.suggession"/>
          </strong>{" "}
        </p>
      ) : null}
      <div class="container">
        <div class="enroll-header-content enroll-header-bg">
          <div class="enroll-header-content-width">
            <h2>{header}</h2>
            <p>
              <Body />
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Banner;
